const baseURL="https://gouridistribution.com";

export default baseURL;